import React from 'react';

import RowActions from './RowActions';

const columns = (onDelete) => [
  {
    name: 'Date',
    selector: 'attributes.created_at_int',
    sortable: true,
    cell: (row) => row.attributes.created_at,
  },
  {
    name: 'Title',
    selector: 'attributes.title',
    sortable: true,
  },
  {
    name: 'Actions',
    sortable: false,
    width: '150px',
    right: true,
    cell: (row) => <RowActions row={row} onDelete={onDelete} />,
  },
];

export default columns;
